<template>
  <div class="wizard-container">
    <!-- Indikator Langkah -->
    <div class="steps-indicator">
      <div class="step" :class="{ active: step >= 1 }">1. Akun</div>
      <div class="step" :class="{ active: step >= 2 }">2. Data Pribadi</div>
      <div class="step" :class="{ active: step >= 3 }">3. Konfirmasi</div>
    </div>

    <form @submit.prevent="submitForm">
      <!-- Step 1: Data Akun -->
      <div v-show="step === 1" class="step-content">
        <h2>Langkah 1: Data Login</h2>
        <div class="form-group">
          <label for="email">Email</label>
          <input v-model="formData.email" id="email" type="email" placeholder="contoh@email.com" required />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input v-model="formData.password" id="password" type="password" placeholder="Minimal 8 karakter" required />
        </div>
      </div>

      <!-- Step 2: Data Pribadi (Lengkap) -->
      <div v-show="step === 2" class="step-content">
        <h2>Langkah 2: Detail Pendaftaran</h2>
        
        <!-- Bertindak untuk -->
        <div class="form-section">
          <label>Bertindak untuk:</label>
          <div class="radio-group">
            <label><input type="radio" v-model="formData.profile.on_behalf_of" value="My Self" /> Diri Sendiri</label>
            <label><input type="radio" v-model="formData.profile.on_behalf_of" value="Beneficial Owner" /> Pihak yang Diwakili</label>
          </div>
        </div>
        
        <!-- Sudah punya rekening? -->
        <div class="form-section">
          <label>Apakah Anda sudah memiliki rekening di Bank Syariah UAI?</label>
          <div class="radio-group">
            <label><input type="radio" v-model="formData.profile.has_bank_account" value="TIDAK" /> Tidak</label>
            <label><input type="radio" v-model="formData.profile.has_bank_account" value="YA" /> Ya</label>
          </div>
          <div v-if="formData.profile.has_bank_account === 'YA'" class="form-group">
            <label for="bank_account_number">Nomor Rekening</label>
            <input v-model="formData.profile.bank_account_number" id="bank_account_number" />
          </div>
        </div>

        <!-- Data Pribadi -->
        <div class="form-section">
          <h3>Data Pribadi</h3>
          <div class="form-group">
            <label for="fullname">Nama Sesuai Identitas</label>
            <input v-model="formData.profile.full_name_id" id="fullname" placeholder="Nama Lengkap" required />
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="title_before">Gelar Sebelum Nama</label>
              <input v-model="formData.profile.title_before_name" id="title_before" />
            </div>
            <div class="form-group">
              <label for="title_after">Gelar Setelah Nama</label>
              <input v-model="formData.profile.title_after_name" id="title_after" />
            </div>
          </div>
          <div class="form-group">
            <label for="alias_name">Nama Alias</label>
            <input v-model="formData.profile.alias_name" id="alias_name" />
          </div>
          <div class="form-group">
            <label for="mother_maiden_name">Nama Gadis Ibu Kandung</label>
            <input v-model="formData.profile.mother_maiden_name" id="mother_maiden_name" placeholder="Untuk keamanan" required />
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="place_of_birth">Tempat Lahir</label>
              <input v-model="formData.profile.place_of_birth" id="place_of_birth" required />
            </div>
            <div class="form-group">
              <label for="date_of_birth">Tanggal Lahir</label>
              <input v-model="formData.profile.date_of_birth" id="date_of_birth" type="date" required />
            </div>
          </div>
          <div class="form-group">
            <label>Jenis Kelamin</label>
            <div class="radio-group">
              <label><input type="radio" v-model="formData.profile.gender" value="PRIA" /> Pria</label>
              <label><input type="radio" v-model="formData.profile.gender" value="WANITA" /> Wanita</label>
            </div>
          </div>
          <div class="form-group">
            <label>Status Kependudukan</label>
            <div class="radio-group">
              <label><input type="radio" v-model="formData.profile.residential_status" value="PENDUDUK" /> Penduduk</label>
              <label><input type="radio" v-model="formData.profile.residential_status" value="NON_PENDUDUK" /> Non Penduduk</label>
            </div>
          </div>
        </div>
        
        <!-- Identitas -->
        <div class="form-section">
          <h3>Identitas</h3>
          <div class="form-group">
            <label>Jenis Identitas Utama</label>
            <div class="radio-group">
              <label><input type="radio" v-model="formData.profile.id_card_type" value="KTP" /> KTP</label>
              <label><input type="radio" v-model="formData.profile.id_card_type" value="SIM" /> SIM</label>
              <label><input type="radio" v-model="formData.profile.id_card_type" value="PASPOR" /> Paspor</label>
              <label><input type="radio" v-model="formData.profile.id_card_type" value="KITAS" /> Kitas</label>
            </div>
          </div>
          <div class="form-group">
            <label for="id_card_number">Nomor Identitas</label>
            <input v-model="formData.profile.id_card_number" id="id_card_number" required />
          </div>
          <div class="form-group">
            <label for="id_card_expired">Tanggal Berakhir Identitas</label>
            <input v-model="formData.profile.id_card_expired_date" id="id_card_expired" type="date" />
          </div>
        </div>

        <!-- Alamat -->
        <div class="form-section">
          <h3>Alamat</h3>
          <div class="form-group">
            <label for="address">Alamat Sesuai ID</label>
            <textarea v-model="formData.profile.address" id="address" rows="3" required></textarea>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="rt_rw">RT/RW</label>
              <input v-model="formData.profile.rt_rw" id="rt_rw" />
            </div>
            <div class="form-group">
              <label for="village">Kelurahan</label>
              <input v-model="formData.profile.village" id="village" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="district">Kecamatan</label>
              <input v-model="formData.profile.district" id="district" />
            </div>
            <div class="form-group">
              <label for="city">Kota/Kabupaten</label>
              <input v-model="formData.profile.city" id="city" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="province">Provinsi</label>
              <input v-model="formData.profile.province" id="province" required />
            </div>
            <div class="form-group">
              <label for="postal_code">Kode Pos</label>
              <input v-model="formData.profile.postal_code" id="postal_code" />
            </div>
          </div>
          <div class="form-group">
            <label for="country">Negara</label>
            <input v-model="formData.profile.country" id="country" value="Indonesia" />
          </div>
        </div>

        <!-- Informasi Tambahan -->
        <div class="form-section">
          <h3>Informasi Tambahan</h3>
          <div class="form-group">
            <label for="npwp">NPWP</label>
            <input v-model="formData.profile.npwp" id="npwp" />
          </div>
          <div class="form-group">
            <label>Jenis Identitas Tambahan</label>
            <select v-model="formData.profile.additional_id_type">
              <option value="">-- Pilih --</option>
              <option value="SURAT_KETERANGAN_BERKERJA">Surat Keterangan Berkerja</option>
              <option value="SURAT_KETERANGAN_DOMISILI">Surat Keterangan Domisili</option>
              <option value="SURAT_KETERANGAN_USAHA">Surat Keterangan Usaha</option>
              <option value="LAINNYA">Lainnya</option>
            </select>
          </div>
          <div v-if="formData.profile.additional_id_type === 'LAINNYA'" class="form-group">
            <input v-model="formData.profile.additional_id_other" placeholder="Sebutkan" />
          </div>
        </div>

        <!-- Agama -->
        <div class="form-section">
          <h3>Agama</h3>
          <div class="radio-group">
            <label><input type="radio" v-model="formData.profile.religion" value="ISLAM" /> Islam</label>
            <label><input type="radio" v-model="formData.profile.religion" value="KRISTEN" /> Kristen</label>
            <label><input type="radio" v-model="formData.profile.religion" value="KATOLIK" /> Katolik</label>
            <label><input type="radio" v-model="formData.profile.religion" value="HINDU" /> Hindu</label>
            <label><input type="radio" v-model="formData.profile.religion" value="BUDDHA" /> Buddha</label>
            <label><input type="radio" v-model="formData.profile.religion" value="KHONG_HU_CU" /> Khong Hu Cu</label>
            <label><input type="radio" v-model="formData.profile.religion" value="LAINNYA" /> Lainnya</label>
          </div>
          <div v-if="formData.profile.religion === 'LAINNYA'" class="form-group">
            <input v-model="formData.profile.religion_other" placeholder="Sebutkan agama lain" />
          </div>
        </div>

        <!-- Pekerjaan & Pendidikan -->
        <div class="form-section">
          <h3>Status Pekerjaan & Pendidikan</h3>
          <div class="form-group">
            <label>Status Pekerjaan</label>
            <select v-model="formData.profile.job_status" required>
              <option value="">-- Pilih --</option>
              <option value="PEGAWAI_NEGERI_SIPIL">PNS</option>
              <option value="PEGAWAI_SWASTA">Pegawai Swasta</option>
              <option value="WIRAUSAHA">Wirausaha</option>
              <option value="MAHASISWA">Mahasiswa</option>
              <option value="PELAJAR">Pelajar</option>
              <option value="TUNA_KARYA">Tuna Karya</option>
              <option value="LAINNYA">Lainnya</option>
            </select>
          </div>
          <div v-if="formData.profile.job_status === 'LAINNYA'" class="form-group">
            <input v-model="formData.profile.job_status_other" placeholder="Sebutkan status pekerjaan lain" />
          </div>
          <div class="form-group">
            <label>Pendidikan Terakhir</label>
            <select v-model="formData.profile.education_level" required>
              <option value="">-- Pilih --</option>
              <option value="SD">SD</option>
              <option value="SMP">SMP</option>
              <option value="SMA">SMA</option>
              <option value="DIPLOMA">Diploma</option>
              <option value="S1">S1</option>
              <option value="S2">S2</option>
              <option value="S3">S3</option>
              <option value="LAINNYA">Lainnya</option>
            </select>
          </div>
          <div v-if="formData.profile.education_level === 'LAINNYA'" class="form-group">
            <input v-model="formData.profile.education_level_other" placeholder="Sebutkan pendidikan lain" />
          </div>
        </div>

        <!-- src/components/RegistrationWizard.vue -->
        <!-- GANTI BLOK LAMA DENGAN INI -->

        <!-- Sumber Dana -->
        <div class="form-section">
          <h3>Sumber Dana</h3>
          
          <div class="form-group">
            <label for="salary-range">Gaji / Pemasukan Utama per Bulan</label>
            <select v-model="formData.profile.salary_range" id="salary-range">
              <option :value="null" disabled>-- Pilih Rentang Pemasukan --</option>
              <option value="<Rp5JT">&lt; Rp 5 Juta</option>
              <option value="Rp5JT-Rp10JT">Rp 5 Juta - Rp 10 Juta</option>
              <option value="Rp10JT-Rp25JT">Rp 10 Juta - Rp 25 Juta</option>
              <option value="Rp25JT-Rp50JT">Rp 25 Juta - Rp 50 Juta</option>
              <option value="Rp50JT-Rp100JT">Rp 50 Juta - Rp 100 Juta</option>
              <option value=">Rp100JT">&gt; Rp 100 Juta</option>
            </select>
          </div>

          <div class="form-group">
            <label for="other-income-range">Pemasukan Lainnya per Bulan (jika ada)</label>
            <select v-model="formData.profile.other_income_range" id="other-income-range">
              <option :value="null">-- Tidak Ada --</option>
              <option value="<Rp5JT">&lt; Rp 5 Juta</option>
              <option value="Rp5JT-Rp10JT">Rp 5 Juta - Rp 10 Juta</option>
              <option value="Rp10JT-Rp25JT">Rp 10 Juta - Rp 25 Juta</option>
              <option value="Rp25JT-Rp50JT">Rp 25 Juta - Rp 50 Juta</option>
              <option value="Rp50JT-Rp100JT">Rp 50 Juta - Rp 100 Juta</option>
              <option value=">Rp100JT">&gt; Rp 100 Juta</option>
            </select>
          </div>

          <div class="form-group">
            <label for="source-of-funds">Deskripsi Sumber Dana</label>
            <input 
              v-model="formData.profile.source_of_funds" 
              id="source-of-funds" 
              type="text" 
              placeholder="Contoh: Gaji bulanan, hasil usaha, warisan" 
            />
          </div>

        </div>


        <!-- Jabatan & Mulai Bekerja -->
        <div class="form-section">
          <h3>Jabatan</h3>
          <div class="form-group">
            <input v-model="formData.profile.position" placeholder="Contoh: Manajer Keuangan" />
          </div>
          <div class="form-group">
            <label for="start_working_date">Mulai Bekerja</label>
            <input v-model="formData.profile.start_working_date" id="start_working_date" type="date" />
          </div>
        </div>

        <!-- Akad -->
        <div class="form-section">
          <h3>Akad</h3>
          <div class="radio-group">
            <label><input type="radio" v-model="formData.profile.akad" value="MUDHARABAH" /> Mudharabah</label>
            <label><input type="radio" v-model="formData.profile.akad" value="WADIAH" /> Wadiah</label>
          </div>
        </div>
      </div>
      
      <!-- Step 3: Konfirmasi -->
      <div v-show="step === 3" class="step-content">
        <h2>Langkah 3: Konfirmasi</h2>
        <p>Silakan periksa kembali data Anda sebelum menyelesaikan pendaftaran.</p>
        <div class="summary-box">
          <p><strong>Email:</strong> {{ formData.email }}</p>
          <p><strong>Nama:</strong> {{ formData.profile.full_name_id }}</p>
          <p><strong>Agama:</strong> {{ formData.profile.religion }}</p>
          <p><strong>Pekerjaan:</strong> {{ formData.profile.job_status }}</p>
          <p><strong>Akad:</strong> {{ formData.profile.akad }}</p>
        </div>
        <p v-if="error" class="error-message">{{ error }}</p>
      </div>

      <!-- Tombol Navigasi -->
      <div class="navigation-buttons">
        <button type="button" @click="prevStep" v-if="step > 1" :disabled="isSubmitting" class="btn">
          Kembali
        </button>
        <button type="button" @click="nextStep" v-if="step < 3" :disabled="isSubmitting" class="btn btn-primary">
          Lanjutkan
        </button>
        <button type="submit" v-if="step === 3" :disabled="isSubmitting" class="btn btn-primary">
          {{ isSubmitting ? 'Mendaftar...' : 'Selesaikan Pendaftaran' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import api from '@/services/api';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';

const toast = useToast();
const router = useRouter();

const step = ref(1);
const isSubmitting = ref(false);
const error = ref(null);

const formData = reactive({
  email: '',
  password: '',
  profile: {
    on_behalf_of: 'My Self',
    has_bank_account: 'TIDAK',
    bank_account_number: null,
    full_name_id: '',
    title_before_name: null,
    title_after_name: null,
    alias_name: null,
    mother_maiden_name: '',
    place_of_birth: '',
    date_of_birth: '',
    gender: 'PRIA',
    residential_status: 'PENDUDUK',
    id_card_type: 'KTP',
    id_card_number: '',
    id_card_expired_date: null,
    address: '',
    rt_rw: null,
    village: null,
    district: null,
    city: '',
    province: '',
    postal_code: null,
    country: 'Indonesia',
    npwp: null,
    additional_id_type: null,
    additional_id_other: null,
    religion: 'ISLAM',
    job_status: '',
    job_status_other: null,
    education_level: '',
    education_level_other: null,
    salary_range: null,
    other_income_range: null,
    source_of_funds: null,
    occupation: 'null',
    occupation_other: null,
    position: null,
    start_working_date: null,
    akad: '',
    akad_other: null,
  }
});

const validateStep = (currentStep) => {
  if (currentStep === 1) {
    if (!formData.email || !formData.password || formData.password.length < 8) {
      toast.error("Email dan Password (minimal 8 karakter) harus diisi.");
      return false;
    }
  }
  if (currentStep === 2) {
    const required = [
      formData.profile.full_name_id,
      formData.profile.mother_maiden_name,
      formData.profile.id_card_number,
      formData.profile.address,
      formData.profile.city,
      formData.profile.province,
      formData.profile.job_status,
      formData.profile.education_level,
      formData.profile.occupation,
      formData.profile.akad
    ];
    if (required.some(field => !field)) {
      toast.error("Harap lengkapi semua field wajib.");
      return false;
    }
  }
  return true;
};

const nextStep = () => {
  if (validateStep(step.value)) {
    step.value++;
  }
};

const prevStep = () => {
  if (step.value > 1) {
    step.value--;
  }
};

const submitForm = async () => {
  if (isSubmitting.value) return;
  
  isSubmitting.value = true;
  error.value = null;

  try {
    // Bersihkan field tanggal kosong
    const payload = { ...formData };
    if (!payload.profile.id_card_expired_date) payload.profile.id_card_expired_date = null;
    if (!payload.profile.start_working_date) payload.profile.start_working_date = null;

    await api.register(payload);
    toast.success("Pendaftaran berhasil! Akun Anda akan divalidasi oleh Supervisor.");
    router.push('/login');
  } catch (err) {
    const detail = err.response?.data?.detail;
    if (Array.isArray(detail)) {
      error.value = detail.map(d => `${d.loc[d.loc.length-1]}: ${d.msg}`).join('; ');
    } else {
      error.value = detail || "Terjadi kesalahan saat pendaftaran.";
    }
    toast.error(error.value);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
.wizard-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.steps-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.step {
  padding: 0.5rem;
  color: #aaa;
  border-bottom: 2px solid #eee;
  flex-grow: 1;
  text-align: center;
}

.step.active {
  color: #007bff;
  border-bottom-color: #007bff;
  font-weight: bold;
}

.form-section {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}

.form-section h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #2c3e50;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0.5rem 0;
}

.radio-group label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio-group input[type="radio"] {
  margin-right: 0.5rem;
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0069d9;
}

.error-message {
  color: red;
  margin-top: 1rem;
  padding: 0.5rem;
  background: #f8d7da;
  border-radius: 4px;
}

.summary-box {
  background: #f8f9fa;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 8px;
}
</style>